import React from 'react';
import aboutimg from '../images/header-bg2.png';

function About() {
    return (
        <div className='about'>
            <div className='about-model'>
                <img src={aboutimg} alt=""/>
            </div>
            <div className='about-text'>
                <h2>The KNS <br/>Real Estate & Contracts&reg; Company</h2>
                <p>As a Company with 4+ Year's of Expertise on Real Estate markets and Contracts,<br/>
                we can out-perform any organizational brilliance out there!&#127757;</p>
                <button>Know More</button>
            </div>
            
        </div>
    )
}

export default About
